module.exports = __webpack_public_path__ + "assets/thumb-tele@2x.07853531.png";